import * as React from 'react';

import {RankedStatBar} from './ranked-stat-bar';
import type {Stat} from './types';

import styles from './ranked-stat-bar-list.module.css';

type Props = {
    rankedStats: Stat | null | undefined[];
};

export function RankedStatBarList(props: Props) {
    const {rankedStats} = props;

    // @ts-expect-error
    const listHalf = Math.ceil(rankedStats.length / 2);

    return (
        <div className={styles['ranked-stat-bar-list']}>
            <div>
                {/* @ts-expect-error */}
                {rankedStats.slice(0, listHalf).map((stat, index) => (
                    <RankedStatBar key={`stat-rank-${index + 1}`} rank={index + 1} stat={stat} />
                ))}
            </div>
            <div>
                {/* @ts-expect-error */}
                {rankedStats.slice(listHalf).map((stat, index) => (
                    <RankedStatBar
                        key={`stat-rank-${index + 1 + listHalf}`}
                        rank={index + 1 + listHalf}
                        stat={stat}
                    />
                ))}
            </div>
        </div>
    );
}
